import { useQuery } from '@tanstack/react-query';

import { QueryVariables, StaleTime } from 'queries/types';

import { ticketsEventQuery } from './queries';

export const useTicketsEvent = (
  variables: QueryVariables<typeof ticketsEventQuery>,
  config: Partial<ReturnType<typeof ticketsEventQuery>>,
) => {
  const { data } = useQuery({
    ...ticketsEventQuery(variables),
    staleTime: StaleTime.FOREVER,
    ...config,
  });

  return {
    data: data?.event,
  };
};
